import { useTranslation } from 'react-i18next';
import { version } from '~/../package.json';

import { ReleaseNotesList } from './ReleaseNotesList';

export const ReleaseNotes = () => {
  const { t } = useTranslation('release');

  return (
    <article className="mx-auto flex min-h-full w-full max-w-5xl shrink-0 flex-col gap-6 rounded-xl bg-white p-6 shadow-lg md:p-12">
      {Boolean(version) && (
        <p className="text-sm text-tiga-text-lighter">
          {t(($) => $.releaseNotes.currentlyUsedVersion, { version })}
        </p>
      )}

      <ReleaseNotesList className="flex-1" />
    </article>
  );
};
